/*
 * Consegna stimata.
 * - Card: «Consegna entro ven 16 ott».
 * - Scheda prodotto: «Ricevi il tuo ordine tra mer 14 ott e ven 16 ott» con i passi
 *   Ordina oggi → Spedito → A casa tua.
 * Regola presa dall'app Delivery Date - ETA (vedi impostazioni del tema «Consegna
 * stimata»): sul fuso di Roma; dopo l'orario limite si parte dal giorno dopo; se si
 * parte in un giorno di chiusura si passa al primo giorno lavorativo; da lì si contano
 * i giorni minimi/massimi e quelli prima della spedizione, saltando i giorni di chiusura.
 * Le card aggiunte dopo (filtri, paginazione, raccomandazioni) le compila il MutationObserver.
 */
(() => {
  const config = window.gmEta;
  if (!config) return;

  const GIORNO = 24 * 60 * 60 * 1000;

  function oggiRoma() {
    const parti = Object.fromEntries(
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Rome',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        hourCycle: 'h23',
      })
        .formatToParts(new Date())
        .map((p) => [p.type, p.value])
    );
    // Mezzogiorno UTC: nessun cambio di giorno per ora legale o fuso del visitatore.
    return { data: new Date(Date.UTC(+parti.year, +parti.month - 1, +parti.day, 12)), ora: +parti.hour };
  }

  function aggiungiGiorni(partenza, giorni, chiusi) {
    const data = new Date(partenza);
    let contati = 0;
    while (contati < giorni) {
      data.setUTCDate(data.getUTCDate() + 1);
      if (!chiusi.includes(data.getUTCDay())) contati += 1;
    }
    return data;
  }

  const { data: oggi, ora } = oggiRoma();
  let partenza = config.cutoff > 0 && ora >= config.cutoff ? new Date(oggi.getTime() + GIORNO) : new Date(oggi);
  while (config.chiusi.length < 7 && config.chiusi.includes(partenza.getUTCDay())) {
    partenza = new Date(partenza.getTime() + GIORNO);
  }

  const minimo = Math.min(config.min, config.max);
  const massimo = Math.max(config.min, config.max);
  const date = {
    oggi,
    spedito: aggiungiGiorni(partenza, config.spedizione || 0, config.chiusi),
    min: aggiungiGiorni(partenza, minimo, config.chiusi),
    max: aggiungiGiorni(partenza, massimo, config.chiusi),
  };

  const formato = (opzioni) => new Intl.DateTimeFormat(config.lingua, { timeZone: 'UTC', ...opzioni });
  const completa = formato({ weekday: 'short', day: 'numeric', month: 'short' });
  const giorno = formato({ day: 'numeric' });
  const giornoMese = formato({ day: 'numeric', month: 'short' });

  // «14–16 ott», oppure «30 ott – 2 nov» a cavallo di due mesi.
  function intervallo(da, a) {
    if (da.getTime() === a.getTime()) return giornoMese.format(a);
    if (da.getUTCMonth() === a.getUTCMonth()) return `${giorno.format(da)}–${giornoMese.format(a)}`;
    return `${giornoMese.format(da)} – ${giornoMese.format(a)}`;
  }

  const testi = {
    max: completa.format(date.max),
    oggi: completa.format(date.oggi),
    spedito: completa.format(date.spedito),
    consegna: intervallo(date.min, date.max),
  };

  function compilaCard(riga) {
    const testo = riga.querySelector('.gm-eta__testo');
    if (testo) testo.textContent = riga.dataset.etichetta.replace('[data]', testi.max);
    riga.setAttribute('data-gm-eta-pronto', '');
  }

  function compilaScheda(riquadro) {
    const titolo = riquadro.querySelector('[data-gm-eta-titolo]');
    if (titolo) {
      // Il modello viene dalle traduzioni del tema; le date le genera Intl.
      titolo.innerHTML = riquadro.dataset.titolo
        .replace('[min]', completa.format(date.min))
        .replace('[max]', testi.max);
    }
    riquadro.querySelectorAll('[data-gm-eta-data]').forEach((cella) => {
      cella.textContent = testi[cella.dataset.gmEtaData] || '';
    });
    riquadro.setAttribute('data-gm-eta-pronto', '');
  }

  function compila(radice) {
    radice.querySelectorAll('[data-gm-eta]:not([data-gm-eta-pronto])').forEach(compilaCard);
    radice.querySelectorAll('[data-gm-eta-scheda]:not([data-gm-eta-pronto])').forEach(compilaScheda);
  }

  compila(document);
  new MutationObserver((mutazioni) => {
    for (const m of mutazioni) {
      m.addedNodes.forEach((nodo) => {
        if (nodo.nodeType !== 1) return;
        compila(nodo.parentNode || nodo);
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
